import React, { useState, useEffect } from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Typography,
  Paper,
  Divider,
  CircularProgress,
  Alert
} from '@mui/material';
import { format } from 'date-fns';
import api from '../../../utils/axiosConfig';

const Messages = ({ supplier }) => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchMessages();
  // eslint-disable-next-line react-hooks/exhaustive-deps -- verified intentional deps
  }, [supplier._id]);

  const fetchMessages = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/api/admin/supplier/${supplier._id}/messages`);
      setMessages(response.data);
    } catch (err) {
      setError('Failed to load messages');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      
      <Paper sx={{ height: '60vh', display: 'flex', flexDirection: 'column' }}>
        {/* Messages List */}
        <List sx={{ flex: 1, overflow: 'auto', p: 2 }}>
          {messages.map((message, index) => (
            <React.Fragment key={message._id}>
              <ListItem alignItems="flex-start">
                <ListItemAvatar>
                  <Avatar>
                    {message.sender.name?.[0] || 'U'}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography component="span" variant="subtitle2">
                      {message.sender.name || 'Unknown'}
                      <Typography component="span" variant="caption" sx={{ ml: 2, color: 'text.secondary' }}>
                        {format(new Date(message.createdAt), 'MMM d, yyyy HH:mm')}
                      </Typography>
                    </Typography>
                  }
                  secondary={message.content}
                />
              </ListItem>
              {index < messages.length - 1 && <Divider variant="inset" component="li" />}
            </React.Fragment>
          ))}
          {messages.length === 0 && (
            <Typography variant="body2" color="text.secondary" align="center" sx={{ py: 4 }}>
              No messages yet
            </Typography>
          )}
        </List>
      </Paper>
    </Box>
  );
};

export default Messages; 